import {
  Box,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  Select,
  MenuItem,
  Tab,
  Menu,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Formik, useFormik, Form } from "formik";

import { ArrowBack, Circle, Clear, MoreHoriz } from "@mui/icons-material";


import { TabContext, TabList, TabPanel } from "@mui/lab";



import { Link, useSearchParams } from "react-router-dom";
import WOView from "../../WorkOrder/WOView";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import WorkPlan from "./WorkPlan";

const WO = ({ woId, handleCloseClick}) => {
  const [value, setValue] = useState("1");
  const [jobPlanId, setJobPlanId] = useState("");
  const [workOrderId, setWorkOrderId] = useState("");
  const [woData, setWoData] = useState({});
  const [dotBL, setDotBL] = useState(null);
  const [direction, setDirection] = useState("row");
  const [searchParams, setSearchParams] = useSearchParams();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
   getData()
  }, []);
  const getData=async()=>{
    const wolink = masterAPI["workOrder"].getbyid;
   await axiosPrivate
      .get(`${wolink}/${woId}`)
      .then((res) => {
        console.log(res);
        // DataWO(res.data.result)
        setWoData(res.data.result);
        setJobPlanId(res.data.result.jobPlanId);
        setWorkOrderId(res.data.result.id);
      })
      .catch((e) => {
        setWoData([])
        setJobPlanId([])
        setWorkOrderId([])
        console.log(e, "workorderview");
      });
  }

 
  return (
    <Grid container spacing={"1rem"} sx={{padding:"1rem"}}>
      <Grid
        item
        xs={12}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mb: "1rem",
            gap: "1rem",
          }}
          // sx={{mb:"1rem"}}
        >
          
            
             
          
      
          <Typography
            sx={{
              // color: color.masterDialogTitleColor,
              // fontSize: color.masterDialogFontSize,
              fontSize: color.AssetTitlesize,
              fontWeight: color.sideFontWeightAsset, 
             
              width: "70%" ,
              marginTop:  '10px' 
            }}
          >
            Work Order : {woData.code} : {woData.workOrderName}
          </Typography>
          {/* <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
              <Circle sx={{ fontSize: "0.5rem", color: "green" }} />
              <Typography>{woData.status}</Typography>
            </Box>
            
          </Box> */}

           <IconButton onClick={handleCloseClick}> 
                <Clear />
              </IconButton>
        </Box>
        <TabContext value={value}>
          <Box
            sx={{
              ".css-hg18dx-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                color: color.TabLabelcolor,
                // p: 0.5,
              },
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              TabIndicatorProps={{
                sx: { backgroundColor: color.TabLabelcolor, height: "3px" },
              }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="General" value="1" sx={{ textTransform: "none" }} />
              <Tab label="Work Plan" value="2" sx={{ textTransform: "none" }} />
            </TabList>
          </Box>
          <Box sx={{ mt: "1rem" }}>
            <TabPanel value="1" sx={{ p: 1 }}>
              {/* <CreateGeneral jobPlanIden={handleJobPlanId}/> */}
              <WOView woData={woData} direction={""} />
            </TabPanel>
            <TabPanel value="2">
              <WorkPlan
               
                workOrderId={woId}
              
              />
            </TabPanel>
          </Box>
        </TabContext>
      </Grid>
   
    </Grid>
  );
};

export default WO;
